import { withProps } from 'recompose'
import { getSplitedSpecs } from './helpers'
import SpecsTable from './SpecsTable'

const withSplitedSpecs = withProps(({
  specificationsToDisplay,
  specifications = [],
  specTips = []
}) => ({
  specifications: getSplitedSpecs({ specifications, specTips, specificationsToDisplay })
}))

export default withSplitedSpecs(SpecsTable)
